<template>
  <el-input
    class="input-new-tag"
    size="small"
    autofocus
    maxlength="20"
    :value="value"
    @input="input"
    @blur="handleBlur"
  >
    <i slot="suffix" class="el-input__close el-icon-close" @mousedown="close($event)"></i>
  </el-input>
</template>
<script>

export default {
  data () {
    return {
    };
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  methods: {
    input (val) {
      this.$emit("input", val);
    },
    close(e) {
      e.preventDefault()
      this.$emit("closeTagInput");
    },

    handleBlur () {
      this.$emit("handleBlur")
    }
  },
};
</script>
<style scoped>
::v-deep .el-input__inner{
  border-radius: 30px !important;
  border-color: #000000!important;
  background-color: white!important;
  border:1px solid;
  color: #000000!important;
  height: 26px!important;
  line-height: 26px!important;
  width: 100px;
}

.el-input__close{
  position: relative;
  left: 9px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  vertical-align: middle;
  top: 3px;
}

.el-input__close:hover{
  color: #FFFFFF;
  background-color: #329ca6;
}
</style>
